const DEFAULT_DROPDOWN = {
  text: '-',
  value: null,
};

const STATUSES = [
  {
    text: '-',
    value: '',
  },
  {
    text: 'Published',
    value: 'published',
  },
  {
    text: 'Unpublished',
    value: 'unPublished',
  },
];

const CATALOG_CARS_PAGE_SIZE = 50;

export { DEFAULT_DROPDOWN, STATUSES, CATALOG_CARS_PAGE_SIZE };
